/*
 * Public API Surface of ng-feedback
 */

export * from './lib/ng-renault-feedback.component';
export * from './lib/ng-renault-feedback.module';